
<div class="header">
  <div class='brand-header'>
        <div class='header-app-logo'>
             <!-- <img src="https://assets.r1.rpost.net/assets/Portal/tplogo.gif" alt='ReceiptAuthentication WebSite'/> -->
             <img [src]="rportalTpLogo" alt='ReceiptAuthentication WebSite'/>
        </div>
        <div class='header-text'> {{companyTitle | translate}} </div>
        <div class='header-co-logo'>
            <!-- <img src="https://open.r1.rpost.net/open/brand/_ssczUvesnDD9tjwqAJGV0DURX8IpBWd51R_yO4GEJIdVOCJqc6nWV9mzXf4UpH8rUzhqJ4nsd46lSXao8C15w==" alt='RPost'/> -->
            <img [src]="rpostCompanyLogo" alt='RPost'/>
        </div>
    </div>
</div>
